module.exports = __webpack_public_path__ + "static/img/__3156.b52f24d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__3156.jpg
// module id = QCgW
// module chunks = 0